module.exports = __webpack_public_path__ + "static/img/3.da87b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/KidsWishes/WishPhotos/3.jpg
// module id = 500
// module chunks = 0